import { RackOptions } from '../../../RackTypes'
import { getAccessoryQuantity } from '../../../utils/product-lookup'
import { getDepthSelection, getJCupSelection, getFrontSelection } from '../../../utils/selection-utils'
import { HalfRackBuilder } from './halfRackBuilder'
import { IRogue, BuyRequest } from '@/js/services/RogueTypes'
import { getBuyRequestMeta, getSimpleForBuyRequest } from '@/js/helpers/buy-request'

// Config for RML Half Rack and RM Collegiate Half Rack
export function createHalfRackConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const rack = getSimpleForBuyRequest(buyRequest, rogue)
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const isRML = meta.name.includes('Monster Lite')
  const line = isRML ? 'RML' : 'RM'

  const isDoubleRack = rack.name.includes('Double')
  const isHalfRack = rack.name.includes('Half Rack')
  const isCollegiateRack = isHalfRack && line === 'RM'
  const spotterArms = getAccessoryQuantity(rogue, buyRequest, 'spotter arms')

  return {
    line,
    color        : 'black',
    sixPost      : true,
    hardware     : isRML ? 'isonite' : 'zinc',
    doubleRack   : isDoubleRack,
    isCollegiateRack,
    depth        : getDepthSelection(rack, meta),
    jcup         : getJCupSelection(rogue, buyRequest),
    front        : getFrontSelection(rogue, buyRequest, meta),
    spotterArms,
    plateStorage : '8 long',
    accessories  : [],
  }
}

export function createHalfRack(rogue: IRogue, buyRequest: BuyRequest) {
  const config = createHalfRackConfig(rogue, buyRequest) 
  const part = new HalfRackBuilder(config).build() // No factory needed for this product
  
  return { config, part }
}
